function normalizeCode(value) {
  if (value == null) {
    return null
  }
  const code = String(value).trim()
  return code || null
}

export function resolveOwnReferralCode(data) {
  if (!data || typeof data !== 'object') {
    return null
  }

  const direct = normalizeCode(data.ref_code)
  if (direct) {
    return direct
  }

  const codes = Array.isArray(data.codes) ? data.codes : []
  const link = codes.find((item) => item?.type === 'link')
  return normalizeCode(link?.code)
}
